import Select from 'react-select';
import { useFormikContext, useField } from 'formik';

interface SelectFieldProps {
    name: string;
    label?: string;
    options?: { value: string; label: string }[];
    unSelectValue?: any;
    notifyChange?: (value: any) => void;
}

export const SelectField = ({
    name,
    label,
    options = [],
    notifyChange,
}: SelectFieldProps) => {
    const { setFieldValue } = useFormikContext();
    const [field, meta] = useField(name);

    const handleChange = (selectedOption: any) => {
        setFieldValue(name, selectedOption?.value || '');
        if (notifyChange) notifyChange(selectedOption?.value || '');
    };

    const selectedValue = options.find((o) => o.value === field.value) || null;

    return (
        <div>
            {label && <label className="label">{label}</label>}
            <Select
                name={name}
                options={options}
                value={selectedValue}
                onChange={handleChange}
                isSearchable
                isClearable
                className="mb-3"
            />
            {meta.touched && meta.error && (
                <small className="errorMsg">{meta.error}</small>
            )}
        </div>
    );
};
